import React from "react";
import styled from "styled-components";
import {Input} from "antd";
// import FaSearch from "react-icons/lib/fa/search";

const Wrapper = styled.div`
    width: 100%;
    height: 100%;
`;


const SearchInput = ({
                         value,
                         handleInputChange,
                         hasResults,
                         handleFocus,
                         handleBlur,
                         searchHint,
                         className = '',
    ...props
                     }) => (
    <Wrapper>
        {/* <FaSearch /> */}
        <Input
            onFocus={handleFocus}
            onBlur={handleBlur}
            placeholder={searchHint}
            id="autocomplete-location-input"
            value={value}
            onChange={handleInputChange}
            style={{...inputStyles, ...(hasResults ? {borderBottomRightRadius: 0, borderBottomLeftRadius: 0}: {})}}
            addonAfter={props.children}
        />
    </Wrapper>
);

const inputStyles = {
    height: "100%",
    width: "100%",
    fontSize: 15,
    borderRadius: 3,
    outline: 'none',
    border: 0,
    borderBottom: '1px solid #D3D8DD',
}
export default SearchInput;